import { render, staticRenderFns } from "./ResolDeltaSolSL_Calpak_1d01.vue?vue&type=template&id=70af695a&"
import script from "./ResolDeltaSolSL_Calpak_1d01.vue?vue&type=script&lang=js&"
export * from "./ResolDeltaSolSL_Calpak_1d01.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports